import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  fieldLabel: {
    marginBottom: theme.spacing(1)
  }
}));
